"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrettyJson = void 0;
var _UnformattedBlock = require("./UnformattedBlock");
var _jsxRuntime = require("react/jsx-runtime");
const PrettyJson = ({
  value
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnformattedBlock.UnformattedBlock, {
  children: JSON.stringify(value, (key, val) => {
    if (key === 'graphqlQuery' && typeof val === 'string') {
      return `<br>${val.trim().split('\n').map(line => `    ${line}`).join('<br>')}<br>  `;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- We know that val is a string or an object
    return val;
  }, 2)
});
exports.PrettyJson = PrettyJson;
